if (!customElements.get('eot-collection-browse')) {
  customElements.define('eot-collection-browse', class extends HTMLElement {
    connectedCallback() {
      this.toggle = this.querySelector('[data-stock-toggle]');
      this.counter = this.querySelector('[data-stock-count]');
      this.empty = this.querySelector('[data-stock-empty]');
      if (!this.toggle) return;
      this.onChange = () => this.updateStock();
      this.onReset = () => { this.toggle.checked = false; this.updateStock(); };
      this.toggle.addEventListener('change', this.onChange);
      this.querySelector('[data-stock-reset]').addEventListener('click', this.onReset);
      this.observer = new MutationObserver(() => this.updateStock());
      this.observer.observe(this.querySelector('#ProductGridContainer'), {childList:true,subtree:true});
      this.updateStock();
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.toggle?.removeEventListener('change', this.onChange);
      this.querySelector('[data-stock-reset]')?.removeEventListener('click', this.onReset);
    }
    updateStock() {
      const items = [...this.querySelectorAll('#product-grid > [data-available]')];
      const active = this.toggle.checked;
      let visible = 0;
      items.forEach(item => {
        item.hidden = active && item.dataset.available !== 'true';
        if (!item.hidden) visible++;
      });
      this.classList.toggle('eot-stock-only', active);
      this.counter.hidden = !active;
      this.counter.textContent = this.dataset.stockCount.replace('[count]', visible);
      this.empty.hidden = !active || visible > 0 || items.length === 0;
    }
  });
}
